import React from "react";
import { Link } from "react-router-dom";
import AuxiliaryText from "../common/Typography/AuxiliaryText";

const DropdownRenderer = ({ 
  items, 
  isOpen, 
  className = "text-start px-4",
  variant = "SubMenuDropdown"
}) => {
  if (!isOpen) return null;

  return (
    <ul className={className}>
      {items.map((item, index) => (
        <li key={index}>
          {item.type === "link" ? (
            <Link
              to={item.link}
              onClick={item.onClick}
              className="block py-2 hover:text-primaryblue ease-in-out w-full my-1"
            >
              <AuxiliaryText variant={variant}>
                {item.label}
              </AuxiliaryText>
            </Link>
          ) : (
            <button
              onClick={item.onClick}
              className="block py-2 hover:text-primaryblue ease-in-out w-full my-1 text-left"
            >
              <AuxiliaryText variant={variant}>
                {item.label}
              </AuxiliaryText>
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};

const HeaderDropdownRenderer = ({ 
  items, 
  className = "text-start px-4",
  variant = "SubMenuDropdown"
}) => {
  return (
    <ul className={className}>
      {items.map((item, index) => (
        <li key={index}>
          <Link
            to={item.link}
            onClick={item.onClick}
            className="block py-2 hover:text-primaryblue ease-in-out w-full my-1"
          >
            <AuxiliaryText variant={variant}>
              {item.label}
            </AuxiliaryText>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export { DropdownRenderer, HeaderDropdownRenderer };
export default DropdownRenderer;
